<template lang='pug'>
  .sort-view
    template(v-if='!isMobile && productsCount > 0')
      .sort-container.form-group
        label.control-label-inline(v-text='$t("common.sortByColon")')
        select.form-control.sort-selector(@change.prevent='submitSort')
          option.form-option(v-for='option in sortOptions' :value='option.value' v-text='option.text' :selected='option.value === sort')
        i.dropdown-arrow

      .view-container.form-group
        label.control-label-inline(v-text='$t("common.viewColon")')
        select.form-control.view-selector(@change.prevent='submitView')
          option.form-option(v-for='quantity in pageSizes' :value='quantity' v-text='quantity' :selected='quantity === pageSize')
        i.dropdown-arrow

    template(v-else-if='isMobile')
      transition.row(name='sort-slide')
        .sort-list.col-6(:class='{ "with-offline-banner": isOffline }' v-show='showMobileSort')
          .refine-sort
            ul.sort-container
              li.products-sort(v-for='option in sortOptions' :value='option.value' @click.prevent.stop='submitSort')
                a.sort-text(v-text='option.text')
                span.selected(v-if='option.value === sort')
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { productsIndexPageSizes, productsIndexSortOptions } from '@/modules/config/catalogue'

export default {
  computed: {
    ...mapState({
      entityType: state => state.product.entityType,
      productsCount: state => state.product.productsCount,
      pageSize: state => state.product.pageSize,
      sort: state => state.product.sort,
      showMobileSort: state => state.product.showMobileSort,
      isOffline: state => state.layout.isOffline,
      landingPageLayout: state => state.landingPage.layout
    }),

    isMobile: () => vueSupport.isMobile,
    pageSizes: () => productsIndexPageSizes,
    sortOptions () {
      return productsIndexSortOptions(this.entityType, this.landingPageLayout)
    }
  },

  methods: {
    ...mapMutations([
      'setSort',
      'setPageSize',
      'setPage'
    ]),

    submitView (e) {
      this.$store.commit('setPageSize', parseInt(e.target.value))
      this.$store.commit('setPage', 1)
    },

    submitSort (e) {
      const value = this.isMobile ? e.target.getAttribute('value') : e.target.value

      this.$store.commit('setSort', value)
      this.$store.commit('setShowMobileSort', false)
      this.$store.commit('setPage', 1)
    }
  }
}
</script>

<style scoped lang='scss'>
  .sort-slide-enter-active,
  .sort-slide-leave-active {
    transition: height .1s;
  }

  .sort-slide-enter-active {
     height: 205px;
  }

  .sort-slide-enter,
  .sort-slide-leave-active {
      height: 0;
  }

  .sort-slide-leave {
      height: 205px;
  }

  .sort-view {
    display: inline-block;
    margin-right: 25px;

    @include media-breakpoint-only(md) {
      margin-right: 0;
    }
  }

  .sort-container {
    margin-right: 20px;
    display: inline-block;

    .sort-selector {
      width: 140px;
    }
  }

  .view-container {
    display: inline-block;

    .view-selector {
      width: 55px;
    }
  }

  .sort-list {
    position: fixed;
    top: 161px;
    left: 0;
    z-index: 1000;

    &.with-offline-banner {
      top: 161px + $offline-banner-height;
    }

    .refine-sort {
      height: 100%;
      background: $white;
      border: 1px solid $grey;
      border-top: 0;
      font-size: 14px;
      letter-spacing: 2px;
      overflow: hidden;
    }

    .sort-container {
      width: 100%;
      margin: 0;
      box-sizing: border-box;
      float: left;
      letter-spacing: 1px;
      height: auto;
      padding-top: 8px;
      border: 0;
      padding: 0;

      .products-sort {
        border-top: 1px solid $grey;
        width: 100%;
        float: left;
        padding: 8px 5%;
        border-top: 1px solid $grey;
        @include font-weight-book;
        text-align: left;

        .sort-text {
          padding: 0;
          color: $black;
          border: 0;
          display: inline-block;
          padding-bottom: 4px;
          pointer-events: none;
        }
      }

      .selected {
        height: 15px;
        width: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 5px;
        pointer-events: none;
        background: url('../../../assets/images/icons/selected-tick.svg');
      }
    }
  }
</style>
